// extracted by mini-css-extract-plugin
export default {"EmbedImage__wrap-left-image":"styles__EmbedImage__wrap-left-image__yCFc6","EmbedImage__wrap-right-image":"styles__EmbedImage__wrap-right-image__TFz4_"};